<template>
    <div class="JudgeRegionPager">
        <component :is="currentComponent" @currentView="changeComponent"></component>
    </div>
</template>

<script type="text/javascript">
  import cfgRegion from './components/ConfigRegionPager.vue';
  import AllRegion from './components/AllRegionPager.vue';
  import checkProjectConfig from '@/lib/checkProjectConfig';
  
  export default {
    name: 'JudgeRegionPager',
    components: {
        cfgRegion,
        AllRegion
    },
    data () {
        return {
            currentComponent: this.defaultComponent()
        }
    },
    methods: {
      defaultComponent:function(){
          let MCC = this.MoreConfigCountry();
          return MCC == true ? cfgRegion :AllRegion;
      },
      changeComponent (component) {
          this.currentComponent = component;
      },
      MoreConfigCountry(){
          //判断是否有配置 
          let that = this;
          if(checkProjectConfig.setAppThat(that).status()){
              return checkProjectConfig.setAppThat(that).checkValue("Module_RegionPager",true);
          }
          return false;
      }
    }
  }
</script>
<style type="text/css">
.CountryMain{
  position: relative;
}
.CountryMain .van-index-anchor--sticky{
  position: relative;
  transform: none!important;
}
.JudgeRegionPager .van-search .van-field__control,.van-field__left-icon{
  padding: 0.12rem 0;
}
.gethisCountry .van-cell{
  padding:0 0.8rem 0 0.444444rem;
}
</style>